import { render, staticRenderFns } from "./Footnote.vue?vue&type=template&id=a7599132&scoped=true&lang=pug"
var script = {}
import style0 from "./Footnote.vue?vue&type=style&index=0&id=a7599132&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7599132",
  null
  
)

export default component.exports